import { useAuth } from '@/hooks/useAuth'

export function useUserCompanies() {
  return useAuth().companies
}
